import React, { useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/storage';
import {Table} from 'semantic-ui-react'
import RolDropdown from '../../componentes/RolDropdown'

const storage = firebase.storage();

const FileList = () => {
  const [files, setFiles] = useState([]);
  const [rol, setRol] = useState('user');
  const [loading, setLoading] = useState(true);

  const handleRolChange = (event, { value }) => {
    setRol(value);
  };
  // Fetch files from Firebase storage
  useEffect(() => {
    setLoading(true);
    const fetchFiles = async () => {
      const storageRef = storage.ref('documentos');
      const filesRef = storageRef.child(`${rol}`);
      const filesSnapshot = await filesRef.listAll();
      const fileList = await Promise.all(
        filesSnapshot.items.map(async (item) => {
          const metadata = await item.getMetadata();
          return {
            name: item.name,
            created: metadata.timeCreated,
          };
        })
      );
      setFiles(fileList);
      setLoading(false);
    };

    fetchFiles();
  }, [rol]);

  const handleDownload = async (file) => {
    try {
      const fileRef = storage.ref().child(`${file.path}/${file.name}`);
      const downloadURL = await fileRef.getDownloadURL();
      window.open(downloadURL); // Open the file in a new tab
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };
  const handleDelete = async (file) => {
    try {
      const fileRef = storage.ref().child(`${file.path}/${file.name}`);
      await fileRef.delete();
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <div>
      <div>
        <h3>Ver archivos disponibles para:</h3>
        <RolDropdown 
					placeholder='Rol Empleados'
					value={rol} 
					onChange={handleRolChange} 
					all={1} 
				/>
      </div>
      <div  className="body tabla">
          <table><tbody>
          <tr>
              <th>Nombre</th>
              <th>Fecha creado</th>
              <th>Acciones</th>
          </tr>
          {files.map((file, i) => (
            <Table.Row key={i}>
              <Table.Cell>{file.name}</Table.Cell>
              <Table.Cell>{file.created}</Table.Cell>
              <Table.Cell>
                <button onClick={()=>{handleDownload(file)}}>Descargar</button>
                <button onClick={()=>{handleDelete(file)}}>Borrar</button>
              </Table.Cell>
            </Table.Row>
          ))}
        </tbody></table>
        {files.length < 1 &&
        <div>
          <h2>No hay archivos para este Rol</h2>
        </div>
        }
      </div>
    </div>
    
  );
};

export default FileList;